<template>
    <div class="contact">
        <main class="container">
            <section class="form-content">
                <h1>Get in 
                    <span class="orange">Touch</span>
                </h1>
                <p class="text">
                  You can contact our immediate customer services through: <br>
                  +2349013755187 <br>
                  Reach our mail services for any complaint or opinion <br>on how we can 
                  further increase our services: services@caby.com.ng
                </p>
                <form action=" https://getform.io/f/626e1ed4-fd0a-483e-a4a4-9b22dd191542" method="POST">
                    <div class="">
                        <input type="text" placeholder="Name" name="Name" id="name" required>
                    </div>
                    <div class="">
                        <input type="mail" name="Email" placeholder="Email" id="mail" required>
                    </div>
                    <div class="">
                        <input type="text" placeholder="Phone number" name="phone number" id="number" required>
                    </div>
                    <div>
                        <select name="how" id="">
                            <option value="">How Did you Find us?</option>
                        </select>
                    </div>
                    <div>
                        <button type="submit">SEND</button>
                    </div>
                    <!-- https://getform.io/f/626e1ed4-fd0a-483e-a4a4-9b22dd191542 -->
                </form>
                <div class="reach-us">
                    <div class="image first-child">
                        <img src="@/assets/phone.svg" alt="" srcset="">
                        <div>
                            <p>Phone</p>
                            <p>+234 901 375 5187</p>
                        </div>
                    </div>
                    <div class="image">
                        <img src="@/assets/fax.svg" alt="" srcset="">
                        <div>
                            <p>FAX</p>
                            <p>+234 901 375 5187</p>
                        </div>
                    </div>
                    <div class="image">
                        <img src="@/assets/mail.svg" alt="" srcset="">
                        <div>
                            <p>EMAIL</p>
                            <p>services@caby.com.ng</p>
                        </div>
                    </div>
                </div>
            </section>
            <section class="blue">
                <img src="@/assets/rect-map.png" alt="" srcset="">
            </section>
        </main>
    </div>
</template>
<script>
    export default {
        
    }
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;400;500;700&display=swap');
*{
    margin:0;
    padding:0;
    font-family: 'Montserrat', sans-serif;
}
.contact{
    margin-top:150px;
}
.container{
    display: flex;
    width:100%;
    margin:70px 0;
}
.form-content{
    width:70%;
    padding: 50px 4%;
}
.blue{
    width:30%;
    background: #011a51;
}
.form-content h1{
    font-size: 3rem;
}
.orange{
    color:#ff6600;
}
.text{
    max-width:540px;
    margin:20px 0;
    letter-spacing: 0.1em;
}
form{
    margin:50px 0;
}
#name, #mail, #number, select{
    width:550px;
    padding:15px 10px; 
    margin:10px 0;   
}
button{
    width:550px;
    padding:15px 10px; 
    margin:10px 0;
    border:none;
    color:#fff;
    font-weight: 800;
    background-color: #ff6600;
}
.reach-us{
    display: flex;
    max-width:600px;
}

.image{
    display:flex;
    justify-content: center;
    align-items: center;
    padding:0 1%;
    width:max-content;
    /* border:1px solid red; */
}
.first-child{
    margin:0;
}
.image img{
    width:20px;
    height:20px;
}
.image div{
    margin:0 10px
}

.image div p:nth-child(2){
    color:#ff6600;
}
.blue img{
    position:absolute;
    height:600px;
    top: 25%;
    right:15%;
}
@media screen and (max-width:1300px) {
    .form-content{
        width:90%;
        margin-left:5%;
    }
    #name, #mail, #number, select, button{
        width: 450px;
    }
    .blue img{
        top:27%;
        right:10%;
        width:400px;
    }
 
}
@media screen and (max-width:1024px) and (min-width:767px) {
    
    .form-content{
        width:70%;
        margin-left:21%;
    }
    .blue{
        display:none;
    }
    .reach-us{
        width:100%;
        justify-content: flex-start;
        /* border: 1px solid red;  */
    }
    .image{
        width:max-content;
    }
}
@media screen and (max-width:768px) {
     .container{
        flex-direction: column;
        margin-top:20px;
    } 
    .form-content{
        width:80%;
        margin:0 10%;
        /* margin-top: -100px; */
        /* min-height:100vh; */
    }
    .form-content h1{
        font-size: 2rem;
    }
    .text{
        letter-spacing: 0;
    }
    .blue{
        display:block;
    }
    .blue img{
        height:200px;
        width:100%;
        overflow: hidden;
        /* position:relative; */
        top:790px;
        right:0%;

    }
    #name, #mail, #number, select, button{
        width: 100%;
    }
    .reach-us{
        flex-direction: column;
        align-items: center;
        margin-top:290px;
        /* border:1px solid red; */
    }
    .image{
       width:max-content ;
       margin:10px 0px; 
    }
    .image:last-child{
       padding-left:5px;
    }
  
    
}
</style>